import { Box, CircularProgress, Grid, useTheme } from "@mui/material";
import { useStudentStats } from "../../api/getStudentStats";
import Chart from "react-google-charts";
import { useTenantParameters } from "../../../misc/api/getTenantParameters";

const StudentGraphs = ({ enrollmentId }) => {
  const { data, isLoading } = useStudentStats({ enrollmentId });
  const tenantParameters = useTenantParameters();
  const theme = useTheme();
  if (isLoading) {
    return <CircularProgress />;
  }

  return (
    <Grid container sx={{ height: "100%" }}>
      <Grid item xs={12} md={6}>
        <Chart
          options={{
            title: "Quantidade de acessos",
            colors: [theme.palette.primary.main, theme.palette.secondary.light],
          }}
          loader={<CircularProgress />}
          width={"100%"}
          height={300}
          chartType="BarChart"
          data={[
            ["Nome", "Quantidade", { role: "style" }],
            [
              "Acessos totais do aluno",
              data.totalAccess,
              theme.palette.primary.main,
            ],
            [
              "Média da turma",
              data.avaregeAccessClass,
              theme.palette.secondary.main,
            ],
          ]}
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <Chart
          options={{
            title: "Tempo de acesso",
            colors: [theme.palette.primary.main, theme.palette.secondary.light],
          }}
          loader={<CircularProgress />}
          width={"100%"}
          height={300}
          chartType="BarChart"
          data={[
            ["Nome", "Tempo(minutos)", { role: "style" }],
            [
              "Total de acesso do aluno",
              data.timeAccessStudent,
              theme.palette.primary.main,
            ],
            [
              "Média da turma",
              data.avaregeTimeClass,
              theme.palette.secondary.main,
            ],
          ]}
        />
      </Grid>
    </Grid>
  );
};

export default StudentGraphs;
